export const PERSONAL_EMAIL_DOMAINS = [
    "gmail.com",
    "yahoo.com",
    "yahoo.co.uk",
    "hotmail.com",
    "hotmail.co.uk",
    "outlook.com",
    "outlook.co.uk",
    "aol.com",
    "icloud.com",
    "me.com",
    "mac.com",
    "mail.com",
    "protonmail.com",
    "proton.me",
    "zoho.com",
    "yandex.com",
    "yandex.ru",
    "gmx.com",
    "gmx.net",
    "live.com",
    "live.co.uk",
    "msn.com",
    "qq.com",
    "163.com",
    "126.com",
    "rediffmail.com",
    "web.de",
    "libero.it",
    "cox.net",
    "sbcglobal.net",
    "att.net",
    "comcast.net",
    "verizon.net",
    "charter.net",
];
